import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { NgInject } from '@df/ng/ng-inject';
import { DatepickerComponentDef } from '@df/ui/form/datepicker.component.def';
import { InputMaskDirective } from '@df/ui/form/input-mask.directive';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { CalendarComponent } from '../calendar/calendar.component';

@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    standalone: true,
    imports: [CalendarComponent, FormsModule, InputMaskDirective, MuiInputDirective, OffClickDirective, ToggleModule],
    styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent extends DatepickerComponentDef {
    @Input()
    readonly?: boolean;
    @Input()
    relative?: boolean;

    protected toggleService = inject(ToggleService);
    
    readonly toggleGroup = 'datepicker';
    override onOpened(to?: boolean) {
        if (!to) {
            this.toggleService.close([this.toggleGroup, 0]);
        } else {
            this.toggleService.open([this.toggleGroup, 0]);
        }
    }
}
